import { action, computed, observable } from 'mobx';
import FamilyApi from 'api/family';

class FamilyStore {
    @observable loading = true;
    @observable id;
    @observable.shallow owner;
    @observable.shallow familyMembers = [];

    @computed get isOwner() {
        return this.owner ? this.rootStore.user.id === this.owner.id : false;
    }

    constructor(rootStore) {
        this.rootStore = rootStore;
    }

    @action
    requestMyFamily() {
        this.loading = true;

        const q = FamilyApi.my();
        q.then(res => this.setFamily(res.data));
        return q;
    }


    @action
    requestCreateFamily() {
        const q = FamilyApi.create();
        q.then(res => this.setFamily(res.data));
        // TODO: Catch error
        return q;
    }

    @action.bound
    setFamily(family) {
        this.id = family.id;
        this.owner = family.owner;

        if (family.familyMembers) {
            const store = this;
            this.familyMembers = family.familyMembers.map(item => new FamilyMember(item.id, item.user, store));
        }

        this.loading = false;
    }

    @action
    requestAddMember(member) {
        const q = FamilyApi.memberAdd(member);
        q.then(res => this.addMemberSuccess(res.data));
        // TODO: Error
        return q;
    }

    @action.bound
    addMemberSuccess(member) {
        this.familyMembers.push(new FamilyMember(member.id, member.user, this));
    }
}

export class FamilyMember {
    @observable loading = false;
    id;
    @observable.shallow user;

    constructor(id, user, familyStore) {
        this.family = familyStore;
        this.id = id;
        this.user = user;
    }

    @action
    requestDeleteMember() {
        this.loading = true;

        const q = FamilyApi.memberRemove(this.id);
        q.then(() => this.deleteMemberSuccess());
        return q;
    }

    @action.bound
    deleteMemberSuccess() {
        this.family.familyMembers.remove(this);
    }
}

export default FamilyStore;


// WEBPACK FOOTER //
// ./src/store/familyStore.js